import getCurrentPreferencesSelect from '../get-current'
import { getValueReduxUtil } from '../../../redux/utils/get-value'
import { createSelector } from 'reselect'
import { PREFERENCES_MODEL_KEY } from '../../model'

// 6 pm
const DEFAULT_TRAINING_TIME = '18:00'

const getTrainingTimePreferencesSelect = createSelector(getCurrentPreferencesSelect,
  (preferences) => {
    const time = getValueReduxUtil(preferences,
      PREFERENCES_MODEL_KEY.TRAINING_TIME
    )
    return time || DEFAULT_TRAINING_TIME
  }
)

export default getTrainingTimePreferencesSelect
